export class CallArrivalDataObj {
    xAxisLabels: Array<string>;
    agentsOnCall: Array<number>;
    callsOnHold: Array<number>;
    agentsWaiting: Array<number>;
}

enum OldStateColor {
    AgentsOnContactBackground = "rgba(119,188,127,1)",
    AgentsOnContactBorder = "rgba(61,160,73,1)",
    AgentsWaitingBackground = "rgba(163,133,210,1)",
    AgentsWaitingBorder = "rgba(124,82,191,1)",
    ContactsInQueueBackground = "rgba(209,98,103,1)",
    ContactsInQueueBorder = "rgba(189,32,38,1)",
}

enum NewStateColor {
    AgentsOnContactBackground = "rgba(163,133,210,1)",
    AgentsOnContactBorder = "rgba(124,82,191,1)",
    AgentsWaitingBackground = "rgba(119,188,127,1)",
    AgentsWaitingBorder = "rgba(61,160,73,1)",
}

type CallArrivalStateColor = NewStateColor | OldStateColor;

type StateColors = {
    background: CallArrivalStateColor;
    border: CallArrivalStateColor;
  };

const stateColorMapping: Record<string, StateColors> = {
    AgentsOnContact: {
        background: OldStateColor.AgentsOnContactBackground,
        border: OldStateColor.AgentsOnContactBorder,
    },
    AgentsWaiting: {
        background: OldStateColor.AgentsWaitingBackground,
        border: OldStateColor.AgentsWaitingBorder,
    },
    ContactsInQueue: {
        background: OldStateColor.ContactsInQueueBackground,
        border: OldStateColor.ContactsInQueueBorder,
    },
};

const newColorsMapping: Record<string, StateColors> = {
    AgentsOnContact: {
        background: NewStateColor.AgentsOnContactBackground,
        border: NewStateColor.AgentsOnContactBorder,
    },
    AgentsWaiting: {
        background: NewStateColor.AgentsWaitingBackground,
        border: NewStateColor.AgentsWaitingBorder,
    },
};

export const getCallArrivalStateColor = (
    useNewColors: boolean,
    agentState: string
): CallArrivalStateColor => {
    const colors = useNewColors ? newColorsMapping : stateColorMapping;
    return colors[agentState]?.background || OldStateColor.ContactsInQueueBackground;
};

export const getCallArrivalBorderStateColor = (
    useNewColors: boolean,
    agentState: string
): CallArrivalStateColor => {
    const colors = useNewColors ? newColorsMapping : stateColorMapping;
    return colors[agentState]?.border || OldStateColor.ContactsInQueueBorder;
};
